import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { ProductIntroSection } from './components/ProductIntroSection';
import { EducationSection } from './components/EducationSection';
import { WhyDietsFailSection } from './components/WhyDietsFailSection';
import { MethodSection } from './components/MethodSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { ForWhomSection } from './components/ForWhomSection';
import { NotForWhomSection } from './components/NotForWhomSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ResultsSection } from './components/ResultsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FuturePacingSection } from './components/FuturePacingSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-brand-cream font-sans text-brand-text" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <ProductIntroSection data-id="element-6" />
        <EducationSection data-id="element-7" />
        <WhyDietsFailSection data-id="element-8" />
        <MethodSection data-id="element-9" />
        <WhatYouGetSection data-id="element-10" />
        <ForWhomSection data-id="element-11" />
        <NotForWhomSection data-id="element-12" />
        <HowItWorksSection data-id="element-13" />
        <ResultsSection data-id="element-14" />
        <TestimonialsSection data-id="element-15" />
        <FuturePacingSection data-id="element-16" />
        <OfferSection data-id="element-17" />
        <GuaranteeSection data-id="element-18" />
        <FaqSection data-id="element-19" />
        <FinalCtaSection data-id="element-20" />
      </main>
      <Footer data-id="element-21" />
    </div>;
}